<template>
  <BaseViewComponent
    name="price"
    :is-preview="isPreview"
  >
    <div style="padding: 60px 0;">
      <div class="price-container border-radius-26  q-pa-lg text-p bg-card">
        <div class="text-center q-mb-xl">
          <div class="title-h2 q-mb-md">{{ pageData.priceTitle }}</div>
          <div class="text-p">{{ pageData.priceDescription }}</div>
        </div>
        <div
          v-for="(item, index) in pageData.priceItems"
          :key="index"
          class="row q-mb-lg"
        >
          <div class="col-1">
            <div
              class="item-icon bg-primary flex items-center justify-center"
            >
              <q-icon
                v-if="item.price.type === 'paid'"
                name="far fa-check"
                class="font-color"
              />
              <q-icon
                v-if="item.price.type === 'gift'"
                name="far fa-gift"
                class="font-color"
              />
            </div>
          </div>
          <div class="col q-pr-md">
            <div class="text-weight-medium q-mb-sm">{{ item.title }}</div>
            <div class="text-p">{{ item.description }}</div>
          </div>
          <div
            v-if="item.price.text"
            class="no-wrap text-right"
          >
            <div
              v-if="item.price.type === 'paid'"
              class="price-value inline-block"
            >
              {{ item.price.text }}{{ CURRENCY_DTO[item.price.currency] }}
            </div>
            <div
              v-else
              class="price-gift inline-block"
            >
              {{ item.price.text }}
            </div>
          </div>
        </div>

        <div>
          <q-separator />
          <div class="title-h3 text-uppercase text-center q-my-md">{{ pageData.pricePromoText }}</div>
          <q-separator />
          <BaseButton
            :label="pageData.priceButtonText"
            class="full-width q-mt-lg"
          />
        </div>

      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import BaseButton from 'components/book-landing/render/BaseButton.vue';

const CURRENCY_DTO = {
  USD: '$',
  EUR: '€',
};

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);
</script>

<style lang="scss" scoped>
.item-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
}

.price-container {
  max-width: 800px;
  padding-top: 50px;
  padding-left: 50px;
  padding-right: 50px;
  background: #fff;
  margin: 0 auto;
}

.price-value {
  border: 1px solid #DEDEDE;
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
}

.price-gift {
  color: var(--page-primary-color);
  border: 1px solid var(--page-primary-color);
  padding: 0.2rem 0.5rem;
  border-radius: 6px;
  white-space: pre;
  text-wrap: nowrap;
  display: inline-block;
}
</style>
